export function StatTile({ label, value }: { label: string; value: string }) {
  return (
    <div className="bg-bg-app rounded-[11px] px-4 py-3">
      <div className="text-[11px] font-semibold text-text-muted uppercase tracking-wide">
        {label}
      </div>
      <div className="mt-1 font-display text-[22px] font-semibold">{value}</div>
    </div>
  );
}
